import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { OtpCheckDTO, OtpSendRequest } from '../models/otp';

@Injectable({
  providedIn: 'root'
})
export class OtpService {

  constructor(
    private http: HttpClient,
    private commonService: CommonService
  ) { }

  signUpOtpSend(tel: string){
    let param: OtpSendRequest = new OtpSendRequest()
    param.type = 'SIGN_UP'
    param.tel = tel
    return this.http.post<any>(this.commonService.apiUrl + '/otp/send', param)
  }
  updateTelOtpSend(tel: string){
    let param: OtpSendRequest = new OtpSendRequest()
    param.type = 'UPDATE_TEL'
    param.tel = tel
    return this.http.post<any>(this.commonService.apiUrl + '/otp/send', param)
  }
  signUpOtpCheck(tel: string, code: string, intervalCheckTime: number){
    let param: OtpCheckDTO = new OtpCheckDTO()
    param.type = 'SIGN_UP'
    param.tel = tel
    param.code = code
    param.intervalCheckTime = intervalCheckTime
    return this.http.post<any>(this.commonService.apiUrl + '/otp/check', param)
  }
  findIdOtpSend(tel: string){
    let param: OtpSendRequest = new OtpSendRequest()
    param.type = 'FIND_ID'
    param.tel = tel
    return this.http.post<any>(this.commonService.apiUrl + '/otp/send', param)
  }
  findIdOtpCheck(tel: string, code: string, intervalCheckTime: number){
    let param: OtpCheckDTO = new OtpCheckDTO()
    param.type = 'FIND_ID'
    param.tel = tel
    param.code = code
    param.intervalCheckTime = intervalCheckTime
    return this.http.post<any>(this.commonService.apiUrl + '/otp/check', param)
  }
  findPwSend(userId: string){
    return this.http.post<any>(this.commonService.apiUrl + '/otp/' + userId + '/findPw/send', {})
  }
  /*
  findPwOtpSend(tel: string){
    let param: OtpSendRequest = new OtpSendRequest()
    param.type = 'FIND_PW'
    param.tel = tel
    return this.http.post<any>(this.commonService.apiUrl + '/otp/send', param)
  }
  */
  findPwOtpCheck(userId: string, code: string, intervalCheckTime: number){
    let param: OtpCheckDTO = new OtpCheckDTO()
    param.type = 'FIND_PW'
    param.userId = userId
    param.code = code
    param.intervalCheckTime = intervalCheckTime
    return this.http.post<any>(this.commonService.apiUrl + '/otp/check', param)
  }
  updateTelOtpCheck(tel: string, userId: string, code: string, intervalCheckTime: number){
    let param: OtpCheckDTO = new OtpCheckDTO()
    param.type = 'UPDATE_TEL'
    param.tel = tel
    param.userId = userId
    param.code = code
    param.intervalCheckTime = intervalCheckTime
    return this.http.post<any>(this.commonService.apiUrl + '/otp/check', param)
  }
}
